import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const CustomCircularProgress = (props) => {
    return <CircularProgress {...props} />;
};

export { CustomCircularProgress as CircularProgress };
